// client/src/components/CouponInput.jsx
import React, { useState } from 'react';
import axios from 'axios';

const CouponInput = ({ amount, onApplyCoupon }) => {
  const [couponCode, setCouponCode] = useState('');
  const [error, setError] = useState('');
  const [appliedDiscount, setAppliedDiscount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const validateAndApplyCoupon = async () => {
    setError('');
    setIsLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/validate-coupon`, {
        code: couponCode,
        amount
      });

      if (response.data.success) {
        setAppliedDiscount(response.data.discountAmount);
        onApplyCoupon(response.data.discountAmount);
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Error validating coupon');
      setAppliedDiscount(0);
      onApplyCoupon(0);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mb-4">
      <div className="flex gap-2">
        <input
          type="text"
          value={couponCode}
          onChange={(e) => setCouponCode(e.target.value)}
          placeholder="Enter coupon code"
          className="flex-1 p-2 border rounded"
          disabled={isLoading}
        />
        <button
          onClick={validateAndApplyCoupon}
          className={`${isLoading ? 'px-1' : 'px-2 md:px-4'} text-sm md:text-lg py-2 md:py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-blue-300`}
          disabled={!couponCode || isLoading}
        >
          {isLoading ? 'Validating...' : 'Apply'}
        </button>
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      {appliedDiscount > 0 && (
        <p className="text-green-600 text-sm mt-1">
          Discount applied: -₦{appliedDiscount.toLocaleString()}
        </p>
      )}
    </div>
  );
};

export default CouponInput;